import React, { useState, useEffect, useContext } from "react";
import { useQuery } from "@apollo/react-hooks";
import PopUp from "./../Popup";
import Map from "./../Map";
import AdvanceFilters from "../AdvanceFilters";
import CardTeaserList from "./../CardTeaserList";
import PlaceAutocomplete from "./../PlaceAutocomplete";
import Sidebar from "./../Sidebar";
import Queries from "../Queries";
import ProcessFilter from "../ProcessFilter";
import { HelpCenter } from "../HelpCenter";
import "./../Global/accurateGeolocalization";
import { GlobalContext } from "./../Context";
import { BranchButton } from "./../BranchButton";
import { BackButton } from "./../BackButton";
import BranchSchedules from "./../BranchSchedules";

import "./App.scss";
import "./Filters.scss";

const App = () => {
  const [filterState, setFilterState] = useState("loading");
  const [initialTouchClientY, setInitialTouchClientY] = useState(0);
  const globalContext = useContext(GlobalContext);
  const {
    langcode,
    resultsState,
    mapsInstance,
    filtersVisibility,
    resultsVisibility,
    setCtaLink,
    setCountriesInfo,
    setHelpCenterLinks,
    helpCenterLinks,
    advancedFiltersVisibility,
    filterCardState,
    setFilterCardState,
  } = globalContext;

  const { error, data } = useQuery(Queries("filters"), {
    variables: { language: langcode },
  });

  useEffect(() => {
    const req = new Promise(function (resolve, reject) {
      if (data) {
        resolve();
      }
      if (error) {
        reject();
      }
    });

    req
      .then(() => {
        setCtaLink(data.filtersByCountry.results[0].fieldGenericLink);
        setCountriesInfo(data);
        if (
          data.filtersByCountry.results[0].fieldListLink &&
          data.filtersByCountry.results[0].fieldListLink.length !== 0
        ) {
          setHelpCenterLinks(data.filtersByCountry.results[0].fieldListLink);
        }
        setFilterState("ready");
      })
      .catch(() => {
        setFilterState("error");
      });
  }, [
    setFilterState,
    data,
    error,
    setCtaLink,
    setCountriesInfo,
    setHelpCenterLinks,
  ]);

  return (
    <div className="app-container">
      <div className="controls-container">
        {advancedFiltersVisibility && (
          <AdvanceFilters
            data={data}
            key="advanceFilters"
            filterState={filterState}
          />
        )}
        <Sidebar>
          <div className="card-filter-list__container">
            <div
              onTouchMove={(event) => {
                const touchEvent = event.touches[0];
                const touchY = touchEvent.clientY;

                if (touchY < initialTouchClientY) {
                  setFilterCardState("open");
                }
              }}
              onTouchStart={(event) => {
                const touchEvent = event.touches[0];
                const touchY = touchEvent.clientY;
                setInitialTouchClientY(touchY);
              }}
              className={`card-filter-list__content ${
                filterCardState === "open"
                  ? "card-filter-list__content--open"
                  : ""
              } ${!filtersVisibility ? "card-filter-list__content--hide" : ""}`}
            >
              <div className="card-filter-action-container">
                <button
                  className={`card-filter-list__content__return__button ${
                    filterCardState === "open"
                      ? "card-filter-list__content__return__button--open"
                      : ""
                  }`}
                  onClick={() => {
                    if (filterCardState === "close") {
                      setFilterCardState("open");
                    } else if (filterCardState === "open") {
                      setFilterCardState("close");
                    }
                  }}
                  onTouchEnd={(e) => {
                    e.preventDefault();
                    e.target.click();
                  }}
                >
                  Empezar búsqueda
                </button>
              </div>
              <div className="card-filter-list__cards">
                <form>
                  <ProcessFilter data={data} filterState={filterState} />
                  {mapsInstance && filtersVisibility ? (
                    <PlaceAutocomplete />
                  ) : null}
                  {helpCenterLinks && helpCenterLinks.length !== 0 && (
                    <HelpCenter />
                  )}
                </form>
              </div>
            </div>
          </div>
          {resultsState ? <CardTeaserList data={data} /> : null}
          <BackButton />
        </Sidebar>
        <BranchButton data={data} />
        <PopUp />
        <BranchSchedules />
      </div>
      <div
        className={`map-container ${
          resultsVisibility & !resultsState ? "map-container--hide" : ""
        }`}
      >
        <Map />
      </div>
    </div>
  );
};

export const AppContext = React.createContext();
export default App;
